export default {
  path: '/aiChat/iframe',
  name: 'aiChatIframe',
  redirect: '/thirdparty/externalAiChatIframe'
};
